<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" class="scrolled uncorupted" :merchandise="true"/>
    <McHeader class="scrolled" title="Checkout" :canGoBack="true"/>
    <div class="cnt">
      <div class="checkout">
        <div class="checkoutInfo">
          <div class="address">
            <h4 class="sectionTitle">Alamat pengiriman</h4>
            <div class="loadingAddress" v-if="loadingAddress">
              <div class="lAdd1"></div>
              <div class="lAdd2"></div>
            </div>
            <div v-else>
              <div class="addressCnt" v-if="address">
                <div class="addressItem">
                  <div class="addressLabel">{{address.label}}</div>
                  <h4>{{address.recipient}} <span>({{address.phone}})</span></h4>
                  <div class="addrNotes" v-if="address.notes && address.notes !== ''">
                    {{address.notes}}
                  </div>
                  <div class="theAddress">
                    <p>{{address.userAddress}}<span
                      v-if="address.rtrw">, RT/RW {{address.rtrw}}</span><span
                      v-if="address.subDistrict">, Desa {{address.subDistrict}}</span><span
                      v-if="address.district">, Kec. {{address.district}}</span><span
                      v-if="address.cityName">, Kota {{address.cityName}}</span><span
                      v-if="address.provinceName">, Provinsi {{address.provinceName}}</span><span
                      v-if="address.postalCode"> - {{address.postalCode}}</span></p>
                  </div>
                </div>
              </div>
              <div class="adressAction">
                <button class="btn secondary" v-on:click="addAddress">Tambah Alamat Baru</button>
                <button class="btn secondary" v-if="address"
                  v-on:click="showAddress">Pilih Alamat Lain</button>
              </div>
            </div>
          </div>
          <div class="deliveryInfo">
            <h4 class="sectionTitle">Kurir pengirim</h4>
            <div class="loadingCourier" v-if="loadingCourier"></div>
            <div class="noCourier" v-else-if="couriers.length < 1">
              <div v-if="!address">
                <h4>Belum ada alamat</h4>
                <p>Tambahkan alamat untuk memilih kurir pengiriman.</p>
              </div>
              <div v-else>
                <h4>Tidak ada kurir tersedia</h4>
                <p>Tidak ada kurir ditemukan untuk pengiriman ke alamat kamu, coba
                  pilih alamat lain.</p>
              </div>
            </div>
            <div class="courierCnt" v-else>
              <div class="theCourier" v-on:click.stop="courierDd = !courierDd"
                v-if="selectedCourier">
                <div class="courierLogo" :class="selectedCourier.code"></div>
                <h4>{{selectedCourier.name}}</h4>
                <div class="courierLabel">{{selectedCourier.cost.description}}
                  ({{selectedCourier.cost.service}})
                  - ETD {{selectedCourier.cost.cost[0].etd}}</div>
                <div class="courierPrice">Rp {{selectedCourier
                  .cost.cost[0].value.toLocaleString('id')}}</div>
              </div>
              <div class="courierDd" v-if="courierDd"
                v-on:click.stop="doNothing">
                <div v-for="(c1, i1) in couriers" :key="`c1${i1}`">
                  <div class="courierLabel">{{c1.name}}</div>
                  <div class="courierItem" v-for="c2, i2 in c1.costs" :key="`c2${i2}`"
                    v-on:click="selectCourier(c1, c2)">
                    <div class="courierLogo" :class="c1.code"></div>
                    <h4>{{c2.description}}</h4>
                    <p>{{c2.service}} - ETD {{c2.cost[0].etd}}</p>
                    <div class="courierPrice">Rp {{c2.cost[0].value.toLocaleString('id')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="deliveryInsurance" v-on:click="insuranceChanged"
              v-if="!loadingCourier && couriers.length > 0 && 1>2">
              <div class="checkbox" :class="{checked: deliveryInsurance}"></div>
              Asuransi pengiriman
            </div>
          </div>
          <div class="productInfo">
            <h4 class="sectionTitle">Barang di pesan</h4>
            <div class="cartCnt loading" v-if="loadingCart">
              <div class="cartItem">
                <a href="/product/detail">
                  <div class="productImg"></div>
                </a>
                <div class="type">T-SHIRT</div>
                <a href="/product/detail">
                  <h4>Uncorrupted Basic (Navy)</h4>
                </a>
                <div class="priceCnt">
                  <div class="priceDiscount">Rp 150.000</div>
                  <div class="price">Rp 110.000</div>
                </div>
              </div>
            </div>
            <div class="cartCnt" v-else>
              <div v-for="(item, i) in cart" :key="i">
                <div class="cartItem" v-if="item.isSelected === 1">
                  <router-link :to="`/uncorupted/product/${item.product.code}`">
                    <div class="productImg" v-if="item.product.images.length > 0
                      && item.product.images[0].media"
                      :style="{'background-image': `url(${item.product.images[0].media.imageSm})`}">
                    </div>
                    <div class="productImg noImg" v-else></div>
                  </router-link>
                  <div class="type" v-if="item.product.category">
                    {{item.product.category.name}}
                  </div>
                  <router-link :to="`/uncorupted/product/${item.product.code}`">
                    <h4>{{item.product.name}}</h4>
                  </router-link>
                  <div class="qtyCnt">
                    {{item.qty}} barang
                    <span v-if="item.product.weight >= 1000">
                      ({{(item.product.weight / 1000).toLocaleString('id')}} kg)
                    </span>
                    <span v-else>
                      ({{item.product.weight.toLocaleString('id')}} gr)
                    </span>
                  </div>
                  <div class="variantCnt" v-if="item.variants.length > 0">
                    <div class="variant" v-for="(v, i) in item.variants"
                      :key="`v${i}`" :class="{color: v.color && v.color !== '#EEEEEE'}">
                      <div class="color" :style="{'background-color': v.color}"
                        v-if="v.color && v.color !== '#EEEEEE'"></div>
                      <span>{{v.label}}:</span>{{v.value}}
                    </div>
                  </div>
                  <div class="priceCnt" v-if="item.product.discount">
                    <div class="priceDiscount">
                      Rp {{item.product.sellPrice.toLocaleString('id')}}
                    </div>
                    <div class="price">Rp
                      {{item.product.discountedPrice.toLocaleString('id')}}</div>
                  </div>
                  <div class="priceCnt" v-else>
                    <div class="price">Rp
                      {{item.product.sellPrice.toLocaleString('id')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="subtotal" v-if="!loadingCart">
              <div class="subtotalLabel">Subtotal</div>
              <div class="subtotalPrice">Rp {{totalPrice.toLocaleString('id')}}</div>
            </div>
          </div>
          <div class="notes">
            <h4 class="sectionTitle">Catatan pembelian</h4>
            <div class="addNotes" v-on:click="showNotes = true"
              v-if="!showNotes">Tambah catatan</div>
            <div class="fieldGroup" v-else>
              <textarea class="field" placeholder="Tulis catatan..." v-model="notes"></textarea>
            </div>
          </div>
          <div class="misc" v-if="cm && cm.enableDonation">
            <div class="miscItem donation" v-on:click="donationChanged">
              <div class="checkbox" :class="{checked: useDonation}"></div>
              <img src="../assets/donation.png">
              {{cm.donationLabel}}
            </div>
          </div>
        </div>
        <div class="priceInfo">
          <div class="loadingPromo" v-if="loadingPromo"></div>
          <div class="promo" v-else-if="promo" v-on:click="addPromo">
            <div class="promoIn">
              Promo diterapkan
              <div class="promoItem">
                <div class="promoName">{{promo.name}}</div>
                <div class="promoPrice">Rp {{promo.value.toLocaleString('id')}}</div>
              </div>
            </div>
          </div>
          <div class="addPromo" v-else v-on:click="addPromo">
            Tambahkan promo tersedia
          </div>
          <h4>Ringkasan belanja</h4>
          <div class="priceInfoItem">
            Total harga barang
            <span>Rp {{totalPrice.toLocaleString('id')}}</span>
          </div>
          <div class="priceInfoItem discount" v-if="promo">
            {{promo.name}}
            <span>-Rp {{promo.value.toLocaleString('id')}}</span>
          </div>
          <div class="priceInfoItem" v-if="selectedCourier">
            Total ongkos kirim
            <span>Rp {{selectedCourier.cost.cost[0].value.toLocaleString('id')}}</span>
          </div>
          <div class="priceInfoItem" v-if="deliveryInsurance">
            Asuransi pengiriman
            <span>Rp 1.400</span>
          </div>
          <div class="priceInfoItem" v-if="useDonation && cm">
            Donasi
            <span>Rp {{cm.donationAmount.toLocaleString('id')}}</span>
          </div>
          <div class="priceInfoItem subtotal">
            Subtotal
            <span>Rp {{subtotal.toLocaleString('id')}}</span>
          </div>
          <div class="priceInfoItem grandTotal">
            Total tagihan
            <span>Rp {{grandTotal.toLocaleString('id')}}</span>
          </div>
          <div class="priceAction">
            <button class="btn primary" :class="{disabled: !selectedCourier}"
              v-on:click="payNow">Pilih Pembayaran</button>
          </div>
        </div>
      </div>
    </div>
    <OtherPaymentDialog ref="otherPaymentDialog"/>
    <Address ref="address"/>
    <AddAddress ref="addAddress"/>
    <PromoSelector ref="promoSelector"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import McHeader from '@/components/McHeader.vue';
import OtherPaymentDialog from '@/components/OtherPaymentDialog.vue';
import Address from '@/components/Address.vue';
import AddAddress from '@/components/AddAddress.vue';
import PromoSelector from '@/components/PromoSelector.vue';

export default {
  name: 'home',
  components: {
    Header,
    Address,
    McHeader,
    PromoSelector,
    OtherPaymentDialog,
    AddAddress,
  },
  data() {
    return {
      loading: false,
      scrolled: false,
      courierDd: false,
      cart: [],
      loadingAddress: true,
      address: null,
      totalPrice: 0,
      loadingCart: true,
      subtotal: 0,
      grandTotal: 0,
      deliveryInsurance: false,
      useDonation: false,
      promo: null,
      selectedCourier: null,
      loadingPromo: false,
      showNotes: false,
      notes: '',
      cm: null,
      couriers: [],
      loadingCourier: true,
    };
  },
  methods: {
    doNothing() {},
    addAddress() {
      this.$refs.addAddress.open(null, (b, v) => {
        if (!b) return;
        this.address = v;
        this.getCourier();
      });
    },
    showAddress() {
      this.$refs.address.open(null, (b, v) => {
        if (!b) return;
        this.address = v;
        this.getCourier();
      });
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
      this.courierDd = false;
    },
    docScrolled() { this.scrolled = (window.pageYOffset >= 30); },
    selectCourier(c1, c2) {
      this.selectedCourier = {
        code: c1.code,
        name: c1.name,
        cost: c2,
      };
      this.courierDd = false;
      this.calcPrice();
    },
    addPromo() {
      this.$refs.promoSelector.open({ amount: this.totalPrice }, (b, p) => {
        if (!b) return;
        this.promo = p;
        this.calcPrice();
      });
    },
    payNow() {
      if (!this.selectedCourier || !this.address) return;
      const paymentData = {
        type: 'product',
        amount: this.grandTotal,
        data: {
          address: this.address,
          products: this.cart,
          deliveryInsurance: this.deliveryInsurance,
          withDonation: this.useDonation,
          courier: this.selectedCourier,
          notes: this.notes,
          promo: this.promo,
          totalProductPrice: this.totalPrice,
          grandTotal: this.grandTotal,
        },
      };
      this.$refs.otherPaymentDialog.open(paymentData, (b) => {
        if (b !== 'payment_failed') {
          if (this.$refs.otherPaymentDialog.trxId) {
            const { trxId } = this.$refs.otherPaymentDialog;
            window.location.href = `/user/transaksi/detail/${trxId}`;
          } else {
            window.location.href = '/user/transaksi';
          }
        }
      });
    },
    donationChanged() {
      this.useDonation = !this.useDonation;
      this.calcPrice();
    },
    insuranceChanged() {
      this.deliveryInsurance = !this.deliveryInsurance;
      this.calcPrice();
    },
    getPromo() {
      const uri = `product/promo/${this.$route.query.promo}?amount=${this.totalPrice}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loadingPromo = false;
        this.promo = (r.data.status === 200) ? r.data.data : null;
        this.getCourier();
      });
    },
    getCourier() {
      this.loadingCourier = true;
      this.selectedCourier = null;
      const addressId = (this.address) ? `addressId=${this.address.id}` : '';
      this.$http.get(this.$config.uri(`user/cart?cost=y&${addressId}`)).then((r) => {
        this.loadingCourier = false;
        this.couriers = (r.data.status === 200) ? r.data.couriers : [];
        if (this.couriers.length > 0) {
          this.selectedCourier = {
            name: this.couriers[0].name,
            cost: this.couriers[0].costs[0],
            code: this.couriers[0].code,
          };
        }
        this.calcPrice();
      });
    },
    calcPrice() {
      this.grandTotal = 0;
      this.grandTotal += this.totalPrice;
      if (this.promo) this.grandTotal -= this.promo.value;
      if (this.selectedCourier) this.grandTotal += this.selectedCourier.cost.cost[0].value;
      if (this.deliveryInsurance) this.grandTotal += 1400;
      if (this.useDonation && this.cm) this.grandTotal += this.cm.donationAmount;
      this.subtotal = this.grandTotal;
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    this.$http.get(this.$config.uri('misc/config/merchandise')).then((r) => {
      this.loading = false;
      if (r.data.status !== 200) {
        // Display error
        return;
      }
      this.cm = r.data.data;
    });
    if (this.$route.query.promo) this.loadingPromo = true;
    this.$http.get(this.$config.uri('user/address?main=y')).then((r2) => {
      this.loadingAddress = false;
      this.address = (r2.data.status === 200) ? r2.data.data : null;
      this.$http.get(this.$config.uri('user/cart')).then((r) => {
        this.loadingCart = false;
        this.cart = r.data.status === 200 ? r.data.data : [];
        // eslint-disable-next-line
        for (const cart of this.cart) {
          // eslint-disable-next-line
          if (!cart.isSelected) continue;
          const sellPrice = (cart.product.discount)
            ? cart.product.discountedPrice : cart.product.sellPrice;
          this.totalPrice += sellPrice * cart.qty;
        }
        if (this.loadingPromo) {
          this.getPromo();
        } else {
          this.getCourier();
        }
      });
    });
  },
};
</script>

<style scoped lang="scss">
.sectionTitle{
  font-size: 18px;
  font-weight: 600;
  margin: 34px 0 10px;
  @media (max-width: 680px) {
    margin-left: 10px;
  }
}
.loadingAddress{
  .lAdd1{
    background-color: #eee;
    height: 100px;
    border-radius: 5px;
    margin-bottom: 10px;
  }
  .lAdd2{
    height: 40px;
    width: 200px;
    background-color: #eee;
    border-radius: 5px;
  }
}
.checkout{
  display: flex;
  padding: 110px 0 80px;
  position: relative;
  @media (max-width: 920px) {
    display: block;
    padding-bottom: 60px;
  }
  @media (max-width: 680px) {
    padding-top: 94px;
    padding-bottom: 40px;
  }
  .checkoutInfo{
    width: calc(100% - 400px);
    @media (max-width: 920px) {
      width: auto;
    }
    .addressCnt{
      padding-bottom: 10px;
      .addressItem{
        border-radius: 5px;
        border: #ddd 1px solid;
        padding: 12px 16px;
        .addrNotes{
          padding: 4px 10px;
          background-image: linear-gradient(to right, #fae502, transparent);
          display: inline-block;
          border-radius: 3px;
          margin: 4px 0 6px;
          padding-left: 30px;
          position: relative;
          &:before{
            content: "";
            position: absolute;
            left: 6px; top: 2px; bottom: 2px; width: 20px;
            background-image: url(../assets/notes.png);
            background-size: 16px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
        .addressLabel{
          font-size: 13px;
          font-weight: 800;
          color: #858585;
          margin: 0 0 4px;
          text-transform: uppercase;
        }
        h4{
          margin: 0 0 4px;
          font-size: 16px;
          font-weight: 600;
        }
        .theAddress{
          font-size: 14px;
          p{
            margin: 0;
          }
        }
      }
    }
    .adressAction{
      .btn{
        font-size: 15px;
        border: #035fae 1px solid;
        padding: 8px 14px;
        margin-right: 10px;
      }
    }
    .deliveryInfo{}
    .noCourier{
      max-width: 460px;
      padding: 10px 16px;
      border: red 1px solid;
      border-radius: 5px;
      background-color: #fffafa;
      color: #910000;
      h4{
        margin: 0 0 2px;
        font-size: 16px;
        font-weight: 600;
      }
      p{
        margin: 0;
        font-size: 14px;
        opacity: .65;
      }
    }
    .loadingCourier{
      max-width: 460px;
      height: 62px;
      background-color: #eee;
      border-radius: 5px;
    }
    .courierCnt{
      position: relative;
      max-width: 460px;
      .theCourier{
        border-radius: 5px;
        border: #ddd 1px solid;
        padding: 10px 16px;
        box-sizing: border-box;
        position: relative;
        padding-left: 68px;
        transition: all .3s ease;
        cursor: pointer;
        &:hover{
          box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          // background-color: #f5f5fe;
        }
        &:before{
          content: "";
          position: absolute;
          right: 12px; top: 13px;
          width: 14px; height: 14px;
          background-image: url(../assets/arrow-down-dd.png);
          background-size: 14px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        .courierLogo{
          position: absolute;
          left: 14px; top: 10px;
          width: 40px; height: 40px;
          background-color: #fff;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          &.jne{
            background-image: url(../assets/courier/courier-jne.png);
          }
          &.pos{
            background-image: url(../assets/courier/courier-pos.png);
          }
          &.tiki{
            background-image: url(../assets/courier/courier-tiki.png);
          }
        }
        h4{
          margin: 0 0 2px;
          font-weight: 600;
          font-size: 16px;
          margin-right: 110px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .courierLabel{
          color: #767676;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .courierPrice{
          position: absolute;
          right: 38px; top: 10px;
          font-weight: 600;
          font-size: 16px;
        }
      }
      .courierDd{
        position: absolute;
        top: 100%;
        left: 0; right: 0;
        background-color: #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .2);
        z-index: 7;
        border-radius: 5px;
        padding-bottom: 20px;
        max-height: 300px;
        overflow-y: auto;
        .courierLabel{
          color: #767676;
          padding: 20px 16px 6px;
          font-size: 14px;
        }
        .courierItem{
          padding: 8px 16px;
          box-sizing: border-box;
          position: relative;
          padding-left: 74px;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            background-color: #f5f5fe;
          }
          .courierLogo{
            position: absolute;
            left: 14px; top: 8px;
            width: 42px; height: 42px;
            background-color: #fff;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            &.jne{
              background-image: url(../assets/courier/courier-jne.png);
            }
            &.pos{
              background-image: url(../assets/courier/courier-pos.png);
            }
            &.tiki{
              background-image: url(../assets/courier/courier-tiki.png);
            }
          }
          h4{
            margin: 0 0 4px;
            font-weight: 600;
            font-size: 15px;
            margin-right: 100px;
          }
          p{
            margin: 0;
            font-size: 13px;
            color: #767676;
          }
          .courierPrice{
            position: absolute;
            right: 16px; top: 10px;
            font-weight: 600;
            font-size: 16px;
          }
        }
      }
    }
    .deliveryInsurance{
      margin-top: 2px;
      padding: 8px 0 7px;
      padding-left: 32px;
      font-weight: 600;
      position: relative;
      display: inline-block;
      cursor: pointer;
      .checkbox{
        left: 0;
      }
    }
    .cartCnt{
      padding-top: 10px;
      .cartItem{
        position: relative;
        margin: 0 0 16px;
        padding: 0 20px;
        padding-left: 56px;
        padding-right: 400px;
        box-sizing: border-box;
        min-height: 56px;
        border-bottom: #eee 1px dashed;
        @media (max-width: 1080px) {
          padding-right: 120px;
        }
        .productImg{
          position: absolute;
          left: 0; top: 3px;
          width: 40px; height: 40px;
          border-radius: 3px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-color: #ccc;
          &.noImg{
            background-image: url(../assets/image-black.png);
            background-size: 18px auto;
            border-color: #ccc;
            opacity: .34;
          }
        }
        .type{
          padding-top: 2px;
          text-transform: uppercase;
          font-size: 12px;
          font-weight: 600;
          color: #6dc3c8;
          display: inline-block;
        }
        h4{
          margin: 0 0 4px;
          font-size: 16px;
          font-weight: 600;
        }
        .qtyCnt{
          font-size: 16px;
          position: absolute; top: 0; right: 160px;
          font-weight: 500;
          @media (max-width: 1080px) {
            position: static;
            font-size: 15px;
            margin: -2px 0 8px;
          }
          span{
            color: #767676;
          }
        }
        .variantCnt{
          display: flex;
          flex-wrap: wrap;
          .variant{
            border-radius: 3px;
            border: #ddd 1px solid;
            padding: 2px 8px 3px;
            font-size: 14px;
            margin: 0 8px 8px 0;
            font-weight: 600;
            position: relative;
            &.color{
              padding-left: 26px;
              .color{
                width: 15px; height: 15px;
                position: absolute;
                left: 4px; top: 4px;
                border-radius: 2px;
              }
            }
            span{
              color: #767676;
              margin-right: 5px;
              font-weight: 400;
            }
          }
        }
        .priceCnt{
          font-size: 16px;
          position: absolute; top: 0; right: 0;
          font-weight: 600;
          text-align: right;
          .priceDiscount{
            color: red;
            text-decoration: line-through;
            display: block;
            font-size: 13px;
          }
        }
      }
      &.loading{
        .cartItem{
          border: none;
          .productImg{
            background-color: #eee;
          }
          .type{
            background-color: #eee;
            color: #eee;
            margin-top: 6px;
            border-radius: 50px;
          }
          h4{
            background-color: #eee;
            color: #eee;
            width: 160px;
            overflow: hidden;
            white-space: nowrap;
            margin-top: 4px;
            border-radius: 50px;
            height: 10px;
          }
        }
        .priceCnt{
          .priceDiscount{
            display: none;
          }
          .price{
            margin-top: 6px;
            background-color: #eee;
            color: #eee;
            border-radius: 50px;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
    .subtotal{
      border-top: #ccc 2px solid;
      margin-top: -17px;
      position: relative;
      z-index: 3;
      padding: 10px 0;
      display: flex;
      font-weight: 600;
      .subtotalPrice{
        margin-left: auto;
        font-weight: 800;
      }
    }
    .notes{
      padding-bottom: 10px;
      .addNotes{
        padding: 8px 14px;
        border-radius: 50px;
        margin-bottom: 20px;
        border: #ccc 1px solid;
        align-items: center;
        display: flex;
        width: 160px;
        cursor: pointer;
        &:hover{
          background-color: #f5f5fe;
        }
        &:before{
          content: "";
          width: 20px; height: 20px;
          background-image: url(../assets/notes.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
          margin-right: 10px;
        }
      }
    }
    .misc{
      border-top: #eee 1px solid;
      .miscItem{
        margin-top: 20px;
        padding: 8px 0 7px;
        padding-left: 32px;
        font-weight: 600;
        position: relative;
        display: inline-block;
        cursor: pointer;
        display: block;
        &.donation{
          padding: 14px 0;
          padding-left: 74px;
          background-image: linear-gradient(to right, transparent, #d1daff);
          background-image: linear-gradient(to right, transparent, #ffd1e2);
          border-radius: 50px;
          padding-right: 20px;
          img{
            position: absolute;
            left: 32px; top: 10px;
            height: 30px;
          }
        }
        .checkbox{
          left: 0;
        }
      }
    }
  }
  .priceInfo{
    width: 360px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
    position: absolute;
    right: 0; top: 140px;
    padding: 20px 24px;
    box-sizing: border-box;
    @media (max-width: 920px) {
      position: static;
      width: auto;
      box-shadow: none;
      padding: 20px 0;
      margin-top: 20px;
    }
    h4{
      margin: 0 0 10px;
      font-size: 17px;
      font-weight: 600;
    }
    .addPromo{
      color: #035fae;
      border: #035fae 1px solid;
      text-align: left;
      padding: 8px 40px;
      margin: 0 0 20px;
      border-radius: 5px;
      position: relative;
      cursor: pointer;
      background-color: #e9f5ff;
      transition: all .3s ease;
      &:hover{
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      }
      &:before{
        content: "";
        position: absolute;
        left: 10px; top: 0; bottom: 0;
        width: 20px;
        background-image: url(../assets/discount-blue.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .loadingPromo{
      margin: 0 0 20px;
      background-color: #eee;
      height: 39px;
      border-radius: 5px;
    }
    .promo{
      margin: 0 -5px 20px;
      background-color: #fff8c0;
      color: #776201;
      text-align: left;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 500;
      position: relative;
      cursor: pointer;
      overflow: hidden;
      &:before{
        content: "";
        position: absolute;
        left: -5px; top: 0; right: -5px; bottom: 0;
        border-left: #fff 10px dotted;
        border-right: #fff 10px dotted;
        z-index: 3;
      }
      &:after{
        content: "";
        right: -20px; top: 50%;
        position: absolute;
        width: 160px; height: 160px;
        margin-top: -80px;
        background-color: #fef08d;
        border-radius: 50%;
      }
      .promoIn{
        position: relative;
        z-index: 3;
      }
      .promoItem{
        display: flex;
        font-weight: 600;
        font-size: 17px;
        .promoName{
          margin-right: 116px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .promoPrice{
          font-weight: 800;
          position: absolute;
          right: 0; top: 50%;
          text-align: right;
          transform: translateY(-50%);
          font-size: 21px;
        }
      }
    }
    .priceInfoItem{
      display: flex;
      // border-bottom: #ccc 1px dashed;
      padding: 5px 0;
      font-size: 14px;
      span{
        margin-left: auto;
        font-weight: 600;
      }
      &.subtotal{
        margin-top: 5px;
        border-top: #ccc 1px dashed;
        font-weight: 600;
      }
      &.discount{
        color: #035fae;
        font-weight: 600;
      }
      &.grandTotal{
        border-bottom: none;
        margin-bottom: 20px;
        border-top: #ccc 2px solid;
        margin-top: 5px;
        font-weight: 600;
        font-size: 17px;
        padding-top: 6px;
        span{
          font-weight: 800;
        }
      }
    }
    .priceAction{
      .btn{
        width: 100%;
      }
    }
  }
}
</style>
